import { render, staticRenderFns } from "./UserOrderSummary.vue?vue&type=template&id=273d98b4&scoped=true"
import script from "./UserOrderSummary.vue?vue&type=script&lang=js"
export * from "./UserOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./UserOrderSummary.vue?vue&type=style&index=0&id=273d98b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d98b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273d98b4')) {
      api.createRecord('273d98b4', component.options)
    } else {
      api.reload('273d98b4', component.options)
    }
    module.hot.accept("./UserOrderSummary.vue?vue&type=template&id=273d98b4&scoped=true", function () {
      api.rerender('273d98b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/UserOrderSummary.vue"
export default component.exports